'use client';

import * as Sentry from '@sentry/nextjs';
import { useEffect } from 'react';

export default function AuthError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen font-sans px-4">
      <h2 className="font-serif text-section-title font-bold text-statura-ink mb-2">
        Authentication Error
      </h2>
      <p className="text-body text-text-muted mb-6">
        Something went wrong during authentication. Please try again.
      </p>
      <button
        onClick={reset}
        className="px-4 py-2 bg-statura-green-accessible text-white text-body font-medium rounded-control hover:bg-statura-green-accessible/90 transition-colors"
      >
        Try again
      </button>
    </div>
  );
}
